export default function Step4() {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5662_70594)">
                <path
                    d="M17.1296 6.36714C19.5039 8.74148 19.5039 12.5911 17.1296 14.9654C16.4035 15.6915 15.5394 16.1955 14.6217 16.4775V23.4576L14.6217 31.9376L11.0391 31.9376V16.4775C10.1215 16.1955 9.25739 15.6915 8.5313 14.9654C6.15696 12.5911 6.15696 8.74147 8.5313 6.36714C9.25739 5.64105 10.1215 5.13699 11.0391 4.85499L11.0391 10.308L14.6217 10.308L14.6217 4.85499C15.5394 5.13701 16.4035 5.64105 17.1296 6.36714Z"
                    stroke="#3F68E0"
                    strokeWidth="1.26"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.5 19.3184C22.5 18.9041 22.8358 18.5684 23.25 18.5684H27.75C28.1642 18.5684 28.5 18.9041 28.5 19.3184V31.3184C28.5 31.7326 28.1642 32.0684 27.75 32.0684H23.25C22.8358 32.0684 22.5 31.7326 22.5 31.3184V19.3184Z"
                    stroke="#3F68E0"
                    strokeWidth="1.26"
                />
                <path
                    d="M23.7 10.4684V18.5684H27.3V10.4684L28.5 8.66836L27.3 5.06836H23.7L22.5 8.66836L23.7 10.4684Z"
                    stroke="#3F68E0"
                    strokeWidth="1.26"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_5662_70594">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.568359)" />
                </clipPath>
            </defs>
        </svg>
    );
}
